import { useState, useEffect } from "react";
import "./modal.scss";
import { transformData } from "../../utils/transformObj";
import { type modalProp } from "./types";
import HandleObj from "./HandleObj";

const Modal = ({ ...props }: modalProp) => {
  const {
    show,
    onHide,
    title,
    children,
    transition,
    data,
    KeysToHide,
    handleViewObjects,
    modalClassName,
    modalStyle,
  } = props;

  const [animate, setanimate] = useState("");
  useEffect(() => {
    setanimate(transition || "unfolding");
  }, [transition]);
  let objBody: TransformedDataProps = {};
  if (data) {
    objBody = transformData(data, KeysToHide, handleViewObjects);
  }
  return (
    <div className="mainContainer">
      <div
        id="modal-container"
        className={`${show ? "modal-active" : "out"} ${show && animate} `}
      >
        <div onClick={onHide} className="overlay"></div>
        <div
          className={`modal-content ${modalClassName}`}
          style={modalStyle||{ background: "white" }}
        >
          <div className="header">
            <span>{title}</span>
            <span
              onClick={onHide}
              style={{ cursor: "pointer" }}
              className="cross"
            >
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAv0lEQVR4nO2VXQrCMBAGxwtalZY86NkVLP6hN6hQCaQgJdXdsFHEDOQt+02TbBooFP6JBrgBB2ChqFsCJ+AK1FrpLBT2YXSAE9S5MHeo8xlqLk8BEvlY6sc5RbyKBE3JY9IuZCRRRwLvwGbUC7E561SpRJ5N+m4rpUdhvvJsK5XKs0qZONNYw31E2ueUu280V/Piykjuubl0wFxeGfwyfYaa1uCR2KeIjwbPos9QU4Uv3iq3zM/dhdp5irhQ+E0ekyummbane5EAAAAASUVORK5CYII=" />
            </span>
          </div>
          <div
            style={{
              padding: 6,
              width: "100%",
              minHeight: "200px",
              boxSizing: "border-box",
            }}
          >
            {children}
            {data && <HandleObj obj={objBody} main />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
